module.exports = "/_next/static/images/a0595590f81f0de60dabdc1f20677e4a-amazon-prime-day-mobile.jpg";